// extracted by mini-css-extract-plugin
export default {"axis":"Axis_axis__zbKvf","dot":"Axis_dot__Y+Kq1","line1":"Axis_line1__NSdkx","line2":"Axis_line2__m5qNo","line3":"Axis_line3__vxoaK"};